import { render } from "./index.vue?vue&type=template&id=65e31450&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=65e31450&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e31450"],['__file',"src/vab/components/VabProductTeam/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65e31450"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65e31450', __exports__)) {
    api.reload('65e31450', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=65e31450&scoped=true", () => {
    api.rerender('65e31450', render)
  })

}


export default __exports__